export default __webpack_public_path__ + "media/zurb/img/ecommerce/loyalty_stats-b5e85de99333427c9a68623612178fd1.png";